import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NavController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { fromEvent, Observable, Subscription } from "rxjs";
import { Comment } from "src/app/app/_component/comment/comment.model";
import { CommentService } from "src/app/app/_component/comment/comment.service";
import { DictionaryService } from "src/app/dictionary";
import { HeaderModel } from "src/app/_component/header/header.model";
import { AuthenticationService, UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { ReportTask } from "../report-task.model";
import { ReportTaskService } from "../report-task.service";

@Component({
  selector: "app-report-task-detail",
  templateUrl: "./report-task-detail.component.html",
  styleUrls: ["./report-task-detail.component.scss"],
})
export class ReportTaskDetailComponent implements OnInit {
  constructor(
    public reportTaskServ: ReportTaskService,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    public dictionaryService: DictionaryService,
    private commentServ: CommentService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    public p: ThisPlatform
  ) {}

  @Input()
  reportTaskId: string;
  
  @Input()
  isModalOpen: boolean = false;

  reportId: string
  idReportTask: number;
  compareWith: any;
  headerInit: HeaderModel = {
    title: "REPORT_TASK.EDIT_TASK",
    backDefaultHref: "/app/report/report-task",
  };

  @Input()
  mobileViewBreakPoint: number = 768;

  @Input()
  task: ReportTask;

  @Output()
  editContractorEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  filterTriggered: EventEmitter<any> = new EventEmitter<any>();

  mobileView: boolean;

  isError: boolean = false;
  errorStatus: number;
  showStatusButtons: boolean = false;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  ngOnInit() {
    if(!this.isModalOpen){
      this.route.paramMap.subscribe((paramMap) => {
        if (!paramMap.has("ReportTaskId")) {
          this.navCtrl.navigateBack("/report");
          return;
        }
        this.reportTaskId = paramMap.get("ReportTaskId");
        if (!paramMap.has("ReportId")) {
          this.navCtrl.navigateBack("/report");
          return;
        }
        this.reportId = paramMap.get("ReportId");

        this.getReportTask();
      });
    } else {
      this.getReportTask();
    }

    setTimeout(() => {
      this.showStatusButtons = true; //hak konieczny do odpalenia przycisków statusu
    }, 0);

    this.mobileView = this.calcMobileView();

    this.resizeObservable$ = fromEvent(window, "resize");
    this.resizeSubscription$ = this.resizeObservable$.subscribe(() => {
      this.mobileView = this.calcMobileView();
    });
  }

  calcMobileView(): boolean {
    return window.innerWidth > this.mobileViewBreakPoint;
  }

  disableEditing() {
    return this.reportTaskServ.reportTask.performedBy.id ===
      this.authenticationService.currentUserValue.id
      ? false
      : true;
  }

  selectedStatusChange(value: number) {
    this.reportTaskServ.reportTask.status = value;

    this.reportTaskServ.updateReportTask().subscribe();
  }

  userChanged(comment: string) {
    this.editContractorEvent.emit(false);
    if (!this.userService.userBasic) return;

    let { firstName, lastName } = this.authenticationService.currentUserValue;
    let newComment = `<strong class="color-pink">${
      firstName ? firstName : ""
    } ${lastName ? lastName : ""}</strong> ${this.translateService.instant(
      "REPORT_TASK.PASSED_TASK_TO"
    )} <strong class="color-pink">${
      this.userService.userBasic.firstName ? this.userService.userBasic.firstName : ""
    } ${
      this.userService.userBasic.lastName ? this.userService.userBasic.lastName : ""
    } </strong>.`;

    if (comment) {
      newComment += "\n\n " + comment;
    }

    this.reportTaskServ.reportTask.idUserPerformedBy = this.userService.userBasic.id;
    this.reportTaskServ.reportTask.performedBy = this.userService.userBasic;
    this.userService.userBasic = null;

    this.commentServ
      .createComment(
        this.reportTaskServ.tableName,
        this.reportTaskServ.reportTask.id,
        newComment,
        true
      )
      .subscribe((res) => {
        this.commentServ
          .getCommentsFilterBy(
            this.reportTaskServ.tableName,
            this.reportTaskServ.reportTask.id
          )
          .subscribe((comments: Comment[]) => {
            this.reportTaskServ.reportTask.comments = comments;
          });
      });

    this.reportTaskServ.updateReportTask().subscribe();
  }

  modalToggle(value) {
    this.editContractorEvent.emit(value);
  }

  ngOnDestroy() {
    if (this.resizeSubscription$) {
      this.resizeSubscription$.unsubscribe();
    }
  }

  getReportTask(){
    this.reportTaskServ
      .getReportTask(this.reportTaskId)
      .toPromise()
      .then((reportTask: ReportTask) => {
        this.reportTaskServ.reportTask = reportTask;
      })
      .catch((error) => {
        this.isError = true;
        this.errorStatus = error.status;
      });
  }
}
